import { array, option } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { getSelectedCityId } from '../../modules/app/selectors';
import { getCityEnterprisesIds } from '../../modules/entities/enterprises/selectors';
import { getEnterpriseServiceId } from '../../modules/entities/services/selectors';
import { ApplicationState } from '../../types';

export const getSelectedCityServiceIds = (state: ApplicationState) => {
    const cityId = getSelectedCityId(state);
    const cityEnterprisesIds = getCityEnterprisesIds(state, { cityId });

    return pipe(
        cityEnterprisesIds,
        array.map(flow((enterpriseId) => getEnterpriseServiceId(state, { enterpriseId }), option.fromNullable)),
        array.compact
    );
};
